/* components/ImpersonationBar.jsx — shown while a superadmin is signed in AS a
 * dealer ("log in as this dealer", 2026-09-07). One click restores the admin
 * session that was parked in localStorage when the impersonation started. */
import React from "react";
import { useAuth } from "@/auth/AuthContext";
import { endImpersonation } from "@/lib/impersonate";

export default function ImpersonationBar() {
  const { user } = useAuth();
  if (!user || !user.impersonated_by) return null;
  return (
    <div data-testid="impersonation-bar" style={{
      position: "fixed", left: "50%", bottom: 14, transform: "translateX(-50%)", zIndex: 99999,
      display: "flex", alignItems: "center", gap: 14, padding: "9px 10px 9px 16px", borderRadius: 999,
      background: "#16140F", color: "#F3F1EC", border: "1px solid rgba(184,149,106,.55)", boxShadow: "0 18px 40px rgba(0,0,0,.35)",
      font: "500 12.5px/1.2 var(--font-sans, Inter, system-ui, sans-serif)", letterSpacing: ".01em", whiteSpace: "nowrap",
    }}>
      <span style={{ width: 8, height: 8, borderRadius: 999, background: "#b8956a", boxShadow: "0 0 0 4px rgba(184,149,106,.2)" }} />
      <span>Signed in as <b>{user.name}</b> · {user.role} — superadmin session</span>
      <button type="button" onClick={endImpersonation} data-testid="impersonation-return" style={{
        font: "inherit", fontWeight: 600, background: "#b8956a", color: "#16140F", border: 0, borderRadius: 999, padding: "8px 14px", cursor: "pointer",
      }}>Return to admin</button>
    </div>
  );
}
